import { Vector3, Quaternion } from "@babylonjs/core/Maths/math.vector";
import { eq } from "../utils/math";
var Helpers = /** @class */ (function () {
    function Helpers() {
    }
    Helpers.Vector3FromEaiwsVector = function (pEVec) {
        var tV = new Vector3();
        Helpers.Vector3CopyFromEaiwsVector(tV, pEVec);
        return (tV);
    };
    Helpers.Vector3CopyFromEaiwsVector = function (pVec3, pEVec) {
        if (pEVec != null) {
            pVec3.x = pEVec.x;
            pVec3.y = pEVec.y;
            pVec3.z = -pEVec.z;
        }
        else {
            pVec3.set(0, 0, 0);
        }
    };
    Helpers.QuaternionFromEaiwsRotation = function (pERot) {
        if (pERot == null || pERot.axis == null || eq(pERot.angle, 0.0)) {
            return (new Quaternion());
        }
        else {
            return (Quaternion.RotationAxis(new Vector3(pERot.axis.x, pERot.axis.y, -pERot.axis.z), -pERot.angle));
        }
    };
    return Helpers;
}());
export { Helpers };
